<script setup lang="ts">
import { ref } from "vue";
import DownloadFile from "./DownloadFile.vue";

defineProps<{ filePath: string; block: string }>();

const isModalOpen = ref(false);
</script>

<template>
    <VFlex flex-direction="column" row-gap="1rem" class="card-c-container">
        <div class="card-block">
            <div class="content-block">
                <div class="title-block my-5">
                    <div class="is-uppercase is-size-5 is-weight-600">
                        <slot name="title"></slot>
                    </div>
                    <div class="is-weight-400 is-size-6">
                        <slot name="subtitle"></slot>
                    </div>
                    <img
                        src="/images/kart/faireDuKart/eclair.svg"
                        class="element-block-card"
                        alt="" />
                </div>
            </div>
        </div>
        <div class="is-uppercase is-size-5 is-weight-700 mt-4 has-text-primary">
            <slot name="title"></slot>
        </div>
        <p class="copy-block has-text-white is-size-6">
            <slot name="content"></slot>
        </p>
        <VFlex class="mt-4">
            <vButton
                class="button is-primary px-5"
                size="huge"
                @click="isModalOpen = true">
                <Translate path=".moreInfos"></Translate>
            </vButton>
        </VFlex>
        <DownloadFile v-model:open="isModalOpen" :file-path="filePath" :block="block">
            <template #title>
                <slot name="title"></slot>
            </template>
            <template #content>
                <slot name="content"></slot>
            </template>
        </DownloadFile>
    </VFlex>
</template>


<style lang="scss">
.card-c-container {
    width: 100%;
}

.card-block {
    position: relative;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
    padding: 1rem;
    width: 100%;
    min-height: 250px;
    box-shadow: 0 1px 1px rgb(0 0 0 / 10%), 0 2px 2px rgb(0 0 0 / 10%),
        0 4px 4px rgb(0 0 0 / 10%), 0 8px 8px rgb(0 0 0 / 10%),
        0 16px 16px rgb(0 0 0 / 10%);
    border-radius: 5px;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 110%;
        background-size: cover;
        background-position: center;
        pointer-events: none;
    }

    &::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 200%;
        pointer-events: none;
        background-image: linear-gradient(
            to bottom,
            rgb(0 112 185 / 0%) 0%,
            rgb(0 112 185 / 30%) 50%,
            rgb(0 112 185 / 70%) 100%
        );
        transform: translateY(-40%);
    }
}

.content-block {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    z-index: 1;
}

.title-block {
    //line-height: 1.2;
}

.element-block-card {
    width: 25px;
    position: absolute;
    top: 25px;
    right: 5px;
}

.copy-block {
    font-size: 1.1rem;
    line-height: 1.2;
}

@media (min-width: 1300px) {
    .card-block {
        min-height: 450px;

        .content-block {
            .title-block {
                div:nth-child(1) {
                    //font-size: 2.5rem !important;
                }
            }

            .copy-block {
                font-size: 1.5rem !important;
                font-weight: 400;
            }
        }
    }
}

@media (min-width: 490px) and (max-width: 1300px) {
    .card-block {
        .content-block {
            .title-block {
                div:nth-child(1) {
                    //font-size: 2rem !important;
                }
            }

            .copy-block {
                font-size: 1.2rem !important;
                font-weight: 400;
            }
        }
    }
}

@media (max-width: 490px) {
    .content-block {
        .title-block {
            div:nth-child(1) {
                //font-size: 1.5rem !important;
            }
        }

        .copy-block {
            font-size: 1rem !important;
            font-weight: 400;
        }
    }
}
</style>
